import { Box, Button, MenuItem, Modal, TextField } from '@mui/material';
import React from 'react';
import { FAQData } from '../../../components/faq/types';
import { StyledHeading } from '../../../components/styles/styles';
import { buildFaqLinkPlaceholder } from './faqAdminUtils';

interface FAQLinkHelperModalProps {
  open: boolean;
  onClose: () => void;
  data: FAQData;
  faqLinkGroup: string;
  faqLinkQuestion: string;
  onGroupChange: (group: string) => void;
  onQuestionChange: (question: string) => void;
  onInsertPlaceholder: (placeholder: string) => void;
}

const FAQLinkHelperModal: React.FC<FAQLinkHelperModalProps> = ({
  open,
  onClose,
  data,
  faqLinkGroup,
  faqLinkQuestion,
  onGroupChange,
  onQuestionChange,
  onInsertPlaceholder,
}) => (
  <Modal open={open} onClose={onClose}>
    <Box
      sx={{
        position: 'absolute',
        top: '20%',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 'min(600px, 95vw)',
        bgcolor: 'background.paper',
        p: 2,
        borderRadius: 2,
        boxShadow: 4,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <StyledHeading headerVariant="subheading">Insert FAQ Link</StyledHeading>
      <TextField
        select
        label="Group"
        size="small"
        fullWidth
        value={faqLinkGroup}
        onChange={(e) => {
          onGroupChange(e.target.value);
          onQuestionChange('');
        }}
      >
        {data.groups.map((g) => (
          <MenuItem key={g.group} value={g.group}>
            {g.group}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label="Question (optional)"
        size="small"
        fullWidth
        value={faqLinkQuestion}
        onChange={(e) => onQuestionChange(e.target.value)}
        disabled={!faqLinkGroup}
      >
        <MenuItem value="">(None — link to group)</MenuItem>
        {data.groups
          .find((g) => g.group === faqLinkGroup)
          ?.items.map((it, idx) => (
            <MenuItem key={`${faqLinkGroup}-${idx}`} value={it.question}>
              {it.question}
            </MenuItem>
          ))}
      </TextField>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!faqLinkGroup}
          onClick={() => {
            onInsertPlaceholder(
              buildFaqLinkPlaceholder(faqLinkGroup, faqLinkQuestion || undefined),
            );
            onClose();
          }}
        >
          Insert
        </Button>
      </Box>
    </Box>
  </Modal>
);

export default FAQLinkHelperModal;
